import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {semantic as dark} from '../../../design-tokens/dark';
import {semantic} from '../../../design-tokens/light';

export const {
  width: $width,
  backgroundColor: $backgroundColor,
  separatorHeight: $separatorHeight,
} = defineCssVars(`thead`, [`width`, `backgroundColor`, `containerColor`, `separatorHeight`]);

export const theadCssVars = (props: StyleFunctionProps) => ({
  [$width.variable]: `sizes.full`,
  [$backgroundColor.variable]: `colors.${mode(
    semantic.colors.background[`elevation-1`],
    dark.colors.background[`elevation-1`],
  )(props)}`,
  [$separatorHeight.variable]: `8px`,
});

const globalActions = defineStyle({
  [`&[data-hover] [data-part=global-actions-trigger]`]: {
    opacity: 1,
    visibility: `visible`,
    userSelect: `auto`,
  },
});

export const theadStyle = defineStyleConfig({
  baseStyle: {
    position: `sticky`,
    top: 0,
    zIndex: 10,
    width: $width.reference,
    backgroundColor: $backgroundColor.reference,
    [`& tr`]: {
      backgroundColor: `inherit`,
    },
    ...globalActions,
  },
});
